import { useState } from 'react';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { X, MessageCircle, Smartphone, Mail } from 'lucide-react';
import { whatsappLink, smsLink, defaultTextMessage } from '@/lib/buyerMessaging';

export function BuyerTagsEditor({ tags = [], onChange }) {
  const [val, setVal] = useState('');
  const add = () => { const t = val.trim(); if (t && !tags.includes(t)) onChange([...tags, t]); setVal(''); };
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="buyer-tags-editor">
      {tags.map(t => (
        <Badge key={t} variant="outline" className="bg-amber-50 text-amber-700 border-amber-200">
          {t}<button onClick={() => onChange(tags.filter(x => x !== t))} className="ml-1" data-testid={`remove-tag-${t}`}><X className="h-3 w-3" /></button>
        </Badge>
      ))}
      <Input data-testid="new-tag-input" value={val} onChange={e => setVal(e.target.value)} onKeyDown={e => e.key === 'Enter' && add()} placeholder="+ tag" className="h-7 w-24 text-xs bg-white border-gray-300" />
    </div>
  );
}

export function BuyerQuickContact({ buyer }) {
  const first = (buyer.name || '').split(' ')[0];
  const msg = defaultTextMessage(null).replace('{{first_name}}', first);
  return (
    <div className="flex gap-2" data-testid="buyer-quick-contact">
      {buyer.phone && <Button asChild size="sm" className="bg-[#25D366] hover:bg-[#1ebe5b] text-white"><a href={whatsappLink(buyer.phone, msg)} target="_blank" rel="noopener noreferrer" data-testid="quick-whatsapp"><MessageCircle className="h-3.5 w-3.5 mr-1" /> WhatsApp</a></Button>}
      {buyer.phone && <Button asChild size="sm" variant="outline"><a href={smsLink(buyer.phone, msg)} data-testid="quick-sms"><Smartphone className="h-3.5 w-3.5 mr-1" /> SMS</a></Button>}
      {buyer.email && <Button asChild size="sm" variant="outline"><a href={`mailto:${buyer.email}`} data-testid="quick-email"><Mail className="h-3.5 w-3.5 mr-1" /> Email</a></Button>}
    </div>
  );
}
